// src/services/campaignService.js
import api from './api';

export const createCampaign = (data) => {
    return api.post('/campaigns', data);
};

export const getCampaigns = () => {
    return api.get('/campaigns');
};

export const deleteCampaign = (id) => {
    return api.delete(`/campaigns/${id}`);
};
